import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider } from "./contexts/AuthContext";
import { Toaster } from "sonner";

import AdminLogin from "./pages/admin/AdminLogin";
import AdminLayout from "./pages/admin/AdminLayout";
import Dashboard from "./pages/admin/Dashboard";
import MenuManagement from "./pages/admin/MenuManagement";
import UserManagement from "./pages/admin/UserManagement";
import TaxRates from "./pages/admin/TaxRates";
import Transactions from "./pages/admin/Transactions";
import Reports from "./pages/admin/Reports";
import AuditLog from "./pages/admin/AuditLog";
import Settings from "./pages/admin/Settings";
import ResetPassword from "./pages/admin/ResetPassword";

import PinLogin from "./pages/pos/PinLogin";
import PosLayout from "./pages/pos/PosLayout";
import RoomLookup from "./pages/pos/RoomLookup";
import MenuBrowse from "./pages/pos/MenuBrowse";
import Cart from "./pages/pos/Cart";
import Receipt from "./pages/pos/Receipt";

function App() {
  return (
    <AuthProvider>
      <Toaster position="top-right" richColors closeButton />
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Navigate to="/pos/login" replace />} />
          <Route path="/pos/login" element={<PinLogin />} />
          <Route path="/pos" element={<PosLayout />}>
            <Route path="room" element={<RoomLookup />} />
            <Route path="menu" element={<MenuBrowse />} />
            <Route path="cart" element={<Cart />} />
            <Route path="receipt" element={<Receipt />} />
          </Route>
          <Route path="/admin/login" element={<AdminLogin />} />
          <Route path="/admin/reset-password" element={<ResetPassword />} />
          <Route path="/admin" element={<AdminLayout />}>
            <Route index element={<Dashboard />} />
            <Route path="menu" element={<MenuManagement />} />
            <Route path="users" element={<UserManagement />} />
            <Route path="taxes" element={<TaxRates />} />
            <Route path="transactions" element={<Transactions />} />
            <Route path="reports" element={<Reports />} />
            <Route path="audit" element={<AuditLog />} />
            <Route path="settings" element={<Settings />} />
          </Route>
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
